// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GHy1","comment":"styles_comment__2MG7z"};